import queryClient from "./query-client";

/** seperator for cache keys, e.g.: {key}{sep}{id} -> LIBRARY_ITEM<sep>1 */
// const CacheKeySeperator = "_@_";
export enum CacheKeyTypes {
  Library = "LIBRARY_@",
  LibraryItem = "LIBRARY_ITEM_@",
  LibraryItemPaths = "LIBRARY_ITEM_PATHS_@",
  LibraryItemState = "LIBRARY_ITEM_STATE_@",
  LibraryItemStateByMediaID = "LIBRARY_ITEM_STATE_BYMEDIAID_@",
  LibraryItemRandom = "LIBRARY_ITEM_RANDOM_@",
  LibraryEvents = "LIBRARY_EVENTS_@",
  Person = "PERSON_@",
  People = "PEOPLE_@",
  Notifications = "NOTIFICATIONS_@",
  HomeHub = "HOME_HUB_@",
  LibraryItemComments = "LIBRARY_ITEM_COMMENTS_@",
  LiCommentEditHistory = "LICEH_@",
  CommentUsersReactedList = "Comment_Users_Reacted_List_@",
  QuickSearchResults = "QUICK_SEARCH_RESULTS_@",
  ManageLibrary = "Manage_Library_@",
  Settings = "SETTINGS_@",
  Feed = "FEED_@",
  LibrarySubscriptions = "LIBRARY_SUBSCRIPTIONS_@",
  ChangeLog = "CHANGELOG_@",
  UserState = "USER_STATE_@",
  Lists = "Lists_@",
  MediaProviders = "Media_Providers_@",
  MediaCountries = "Media_Countries_@",
  MediaCert = "Media_Cert_@",
  MediaEpisodes = "Media_Episodes_@",
  Announcements = "Announcements_@",
  MediaCalendar = "MediaCalendar_@",
  MediaTmdbSearch = "MediaTmdbSearch_@", // rpc media/tmdb-search
  RpcLibraryItems = "library-items_@",
  Feedbacks = "Feedback_@",
}

// const join = (type: CacheKeyTypes, unique_id: string | number): string => `${type}${CacheKeySeperator}${unique_id}`;
export function makeKey(type: CacheKeyTypes, unique_id: string | number): string {
  return `${type}_${unique_id}`;
}

export const invalidateGeneratedKey = (type: CacheKeyTypes, unique_id: number | string) => {
  return queryClient.invalidateQueries(makeKey(type, unique_id));
};

export const invalidateKeysByType = (cacheKeys: CacheKeyTypes[]) => {
  if (!cacheKeys.length) return;
  const regStr = cacheKeys.join("|");
  return queryClient.invalidateQueries({
    predicate: (q) => {
      const re = new RegExp(regStr, "i");
      return re.test(q.queryKey.toString());
    },
  });
};

interface IOpts {
  person: boolean;
  people: boolean;
  library: boolean;
  library_item: boolean;
  home_hub: boolean;
}
/** Invalidates specified cache objects. Useful if you want to, e,g., remove all cached person data. */
export const invalidateSomeQueries = (opts: AtLeastOne<IOpts>) => {
  const { library, library_item, person, people, home_hub } = opts;
  let regStr = "";
  // TODO: change opts type to array of cache keys and use join with |
  if (library) regStr += `${CacheKeyTypes.Library}|`;
  if (library_item) regStr += `${CacheKeyTypes.LibraryItem}|`;
  if (person) regStr += `${CacheKeyTypes.Person}|`;
  if (people) regStr += `${CacheKeyTypes.People}|`;
  if (home_hub) regStr += `${CacheKeyTypes.HomeHub}|`;
  if (!regStr) return;
  regStr = regStr.substr(0, regStr.length - 1); // remove the trailing |
  queryClient.invalidateQueries({
    predicate: (q) => {
      const re = new RegExp(regStr, "i");
      return re.test(q.queryKey.toString());
    },
  });
};
